import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'

import ProfileForm from 'components/ProfileForm'
import ChangePasswordForm from 'components/ChangePasswordForm'

import withAppStore from 'decorators/withAppStore'
import authorized from 'decorators/authorized'

import styles from 'styles/pages/profile'

@withStyles(styles)
@authorized
@withAppStore
@observer
export default class extends Component {

  componentWillMount() {
    this.appStore.pageTitle = 'Профиль пользователя'
  }

  render() {
    const { classes } = this.props

    return (
      <div className={ classes.root } >
        <ProfileForm />
        <ChangePasswordForm />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/profile.js